<template>
	<div class="component-index mt-2 d-flex flex-wrap-wrap" style="align-items: flex-start">
		<!-- <FunctionTitle :title="mainTitle" /> -->

		<CommonFlame
			title="権限名トレー"
			class="flex-flame permission-tray"
			v-show="showPermissionTray"
		>
			<v-card v-draggable>
				<v-card-text>
					<v-list class="d-flex flex-wrap-wrap">
						<v-list-item
							v-for="permission in authorities"
							:key="permission.id"
							:draggable="true"
							class="list-item"
							@dragstart="setDraggingPermission(permission)"
						>
							<v-list-item-title class="line-height-set">{{ permission.name }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card></CommonFlame
		>

		<CommonFlame class="flex-flame" :title="title + ' | ' + department.name">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn color="primary" @click="togglePermissionTray">{{
					showPermissionTray ? "権限名トレー非表示" : "権限名トレー表示"
				}}</v-btn>
			</template>
			<table>
				<!-- <thead>
					<tr>
						<th>ユーザー名</th>
						<th>権限名</th>
					</tr>
				</thead> -->
				<tbody>
					<tr v-for="user in users" :key="user.id">
						<td class="user-cell">{{ user.last_name }} {{ user.first_name }}</td>
						<td
							class="permission-cell"
							@drop.prevent="addPermission(user, $event)"
							@dragover.prevent
						>
							<div
								v-for="(permission, index) in user.authorities"
								:key="index"
								class="permission-tag"
							>
								<div class="permission-name">{{ permission.name }}</div>
								<v-btn icon class="delete-btn" @click="openCheckDialog(user, permission)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</div>
							<div v-if="user.authorities.length === 0" class="empty-message">権限なし</div>
						</td>
					</tr>
				</tbody>
			</table>
		</CommonFlame>
		<CheckDialog ref="checkDialog" @deletePermission="deletePermission" />
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import Qs from "qs"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import PaginationModule from "../../modules/PaginationModule.vue"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CheckDialog from "./components/checkDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		CheckDialog,
	},
	data() {
		return {
			title: "権限割り当て",
			users: [],
			authorities: [],
			showPermissionTray: false,
			draggingPermission: null,
			department: { name: "" },
		}
	},
	mounted() {
		const id = this.$route.params.id // URLからIDを取得
		this.fetchData(id) // IDを引数としてfetchDataメソッドを呼び出し
	},
	methods: {
		fetchData(id) {
			const headers = authenticate.setHeader()
			// サーバーにアクセスしてusersとauthoritiesを取得
			axios
				.get(`/erp/v1/assign_permissions`, { params: { department_id: id }, headers })
				.then((response) => {
					this.department = response.data.department
					this.users = response.data.users
					this.authorities = response.data.permissions
					console.log(this.authorities)
				})
		},
		togglePermissionTray() {
			this.showPermissionTray = !this.showPermissionTray
		},
		addPermission(user, event) {
			const headers = authenticate.setHeader()

			if (this.draggingPermission && !user.authorities.includes(this.draggingPermission)) {
				axios
					.post(
						"/erp/v1/assign_permissions",
						{
							user_id: user.id,
							authority_id: this.draggingPermission.id,
						},
						{ headers }
					)
					.then((response) => {
						// 成功時の処理
						user.authorities.push(this.draggingPermission)
						this.$store.commit("setFlash", {
							text: "追加しました",
							type: "notice",
						})
						this.draggingPermission = null
					})
					.catch((error) => {
						this.draggingPermission = null
						console.error(error)
						errorHandling.errorResponse(err)
					})
			}
		},
		openCheckDialog(user, permission) {
			if (this.authorities.some((item) => item.id === permission.id)) {
				this.$refs.checkDialog.confirmDelete(user, permission)
			} else {
				this.$store.dispatch("setFlash", {
					text: "この部門の権限ではありません",
					type: "alert",
				})
			}
		},
		deletePermission(user, permission) {
			const headers = authenticate.setHeader()
			const index = user.authorities.indexOf(permission)
			if (index > -1) {
				axios
					.delete(`/erp/v1/assign_permissions/${permission.id}`, {
						headers,
						data: {
							user_id: user.id,
						},
					})
					.then((response) => {
						// 成功時の処理
						this.$store.commit("setFlash", {
							text: "削除しました",
							type: "notice",
						})
						user.authorities.splice(index, 1)
					})
					.catch((error) => {
						// エラー時の処理
						console.error(error)
						errorHandling.errorResponse(err)
					})
			}
		},
		setDraggingPermission(permission) {
			this.draggingPermission = permission
		},
	},
}
</script>
<style lang="scss" scoped>
.component-index {
	.permission-tray {
		width: 100%;
		max-width: 300px;
	}
	.list-item {
		width: 100%;
		max-width: 250px;
		cursor: pointer;
		&:hover {
			background-color: #e0e0e0;
		}
	}
	.permission-cell {
		display: flex;
		flex-wrap: wrap;
	}

	.permission-name {
		padding-right: 5px;
	}

	.delete-btn {
		margin-left: 5px;
		padding: 0;
		width: 20px;
		height: 20px;
	}

	.empty-message {
		font-style: italic;
		color: #999;
	}
}
.permission-cell {
	position: relative;
	min-height: 50px;
	border: 1px solid #ccc;
	padding: 5px;
}

.permission-tag {
	display: inline-block;
	background-color: #eee;
	border-radius: 20px;
	padding: 5px 10px;
	margin: 1px 5px 1px 0;
}

.permission-name {
	display: inline-block;
}

.delete-btn {
	margin-left: 5px;
	padding: 0;
	width: 20px;
	height: 20px;
}

.empty-message {
	font-style: italic;
	color: #999;
}
.list-item {
	width: 100%;
	max-width: 250px;
	cursor: pointer;
	&:hover {
		background-color: #e0e0e0;
	}
	.line-height-set {
		line-height: 1.5;
	}
}
.user-cell {
	min-width: 160px;
}
@media (max-width: 700px) {
	table,
	tbody,
	tr {
		display: block;
	}
	td {
		display: block;
	}
	.flex-flame {
		width: 100% !important;
		max-width: 100% !important;
	}
}
</style>
